import { BriefcaseBusiness, Check, Languages } from "lucide-react";
import { useEffect, useState, type FormEvent } from "react";
import { productionLanguages, type ProductionLanguageCode } from "../../shared/brandProduction";
import type { BrandDetailResponse, BrandSummary } from "../../shared/types";
import { api } from "../api";

export function BrandServiceProfile({ brand, onUpdated }: { brand: BrandSummary; onUpdated: (value: BrandDetailResponse) => void }) {
  const [isClient, setIsClient] = useState(brand.isClient);
  const [productionLanguage, setProductionLanguage] = useState<ProductionLanguageCode>(brand.productionLanguage);
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");
  const dirty = isClient !== brand.isClient || productionLanguage !== brand.productionLanguage;

  useEffect(() => {
    setIsClient(brand.isClient);
    setProductionLanguage(brand.productionLanguage);
    setSaved(false);
    setError("");
  }, [brand.slug, brand.isClient, brand.productionLanguage]);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!dirty) return;
    setBusy(true); setError(""); setSaved(false);
    try {
      const value = await api.saveBrandServiceProfile(brand.slug, { isClient, productionLanguage });
      onUpdated(value); setSaved(true);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Could not save this client profile.");
    } finally {
      setBusy(false);
    }
  };

  return <form className="brand-service-profile" onSubmit={(event) => void submit(event)}>
    <div className="brand-service-profile__intro"><BriefcaseBusiness aria-hidden="true" /><div><strong>Client delivery profile</strong><span>Only Brands marked as clients appear in Calendar.</span></div></div>
    <label className="client-status-control"><input type="checkbox" checked={isClient} onChange={(event) => { setIsClient(event.target.checked); setSaved(false); }} /><span><strong>Client</strong><small>Ads are delivered under an active SLA.</small></span></label>
    <label className="production-language-control"><span><Languages size={15} aria-hidden="true" />Production language</span><select value={productionLanguage} onChange={(event) => { setProductionLanguage(event.target.value as ProductionLanguageCode); setSaved(false); }}>{productionLanguages.map((language) => <option value={language.code} key={language.code}>{language.label}</option>)}</select><small>Controls generated scripts, voiceovers, and exact captions.</small></label>
    <div className="brand-service-profile__action">{error ? <span className="field-error" role="alert">{error}</span> : saved ? <span className="saved-note" role="status"><Check size={14} />Saved</span> : <span /> }<button className="secondary-button" disabled={!dirty || busy}>{busy ? "Saving…" : "Save profile"}</button></div>
  </form>;
}
